export default "/images/Sustainable-aviation-fuel.jpg";